<template>
  <button id="REPLAY" name="REPLAY" class="btn" data-vcode="REPLAY">
    <img class="soft-img" src="/images/icn-replay.svg" alt="" role="img" aria-hidden="true" />
    <label>{{ $t('replayButton') }}</label>
  </button>
</template>
<script>
export default {};
</script>
